// src/services/silverApi.js

const SILVER_API_URL = 'https://bcast.kakagold.xyz/VOTSBroadcastStreaming/Services/xml/GetLiveRateByTemplateID/kakasilverbar';

// Parse the tab-separated silver response
const parseSilverData = (text) => {
  console.log('📝 Parsing silver response...');
  const lines = text.split('\n').filter(line => line.trim());
  const products = [];
  
  lines.forEach(line => {
    const parts = line.split('\t').filter(p => p.trim());
    
    if (parts.length >= 6) {
      const id = parts[0].trim();
      const name = parts[1].trim();
      const currentPrice = parseFloat(parts[2]) || 0;
      const askPrice = parseFloat(parts[3]) || 0;
      const highPrice = parseFloat(parts[4]) || 0;
      const lowPrice = parseFloat(parts[5]) || 0;
      console.log(parts);
      // Include silver-related products
      if (name.includes('SILVER') || name.includes('silver') || name.includes('INR') || name.includes('inr') || name.includes('usd') || name.includes('USD')) {
        products.push({
          id: id,
          name: name,
          price: currentPrice,
          ask: askPrice,
          high: highPrice,
          low: lowPrice,
          unit: name.includes('SPOT') ? 'oz' : 'kg',
          source: 'KakaGold Silver'
        });
      }
    }
  });
  
  console.log(`✅ Found ${products.length} silver products`);
  return products;
};

// Fetch live silver rates
export const fetchSilverRates = async () => {
  try {
    const timestamp = new Date().getTime();
    const url = `${SILVER_API_URL}?_=${timestamp}`;
    console.log('🌐 Fetching silver from:', url);
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    console.log('📄 Silver response length:', text.length);
    
    const products = parseSilverData(text);
    
    if (products.length === 0) {
      throw new Error('No silver products found in response');
    }
    
    return products;
  } catch (error) {
    console.error('❌ Error fetching silver rates:', error);
    throw error;
  }
};

// Get specific silver products
export const getSilverSpot = async () => {
  const products = await fetchSilverRates();
  return products.find(p => p.name === 'SILVER SPOT');
};

export const getSilverBar = async () => {
  const products = await fetchSilverRates();
  return products.find(p => p.name.includes('SILVER 999 BAR'));
};

export const getSilverGranules = async () => {
  const products = await fetchSilverRates();
  return products.filter(p => p.name.includes('GRANULES'));
};

// Export for use
const obj = {
  fetchSilverRates,
  getSilverSpot,
  getSilverBar,
  getSilverGranules,
};

export default obj